<template>
  <div class="wrap">
    <div class="header">
      <span
        v-if="!isClassPage"
        class="el-icon-arrow-left"
        style="cursor: pointer; margin-right: 5px; font-size: 18px"
        @click="isClassPage = true"
      >
      </span>
      <h3 class="title">{{ !isClassPage ? courseName : '观看数据' }}</h3>
      <div class="search-box" v-if="false">
        <el-input placeholder="搜索课程名称" v-model="keyword">
          <i slot="suffix" class="el-icon-search" @click="handleSearch"></i>
        </el-input>
      </div>
    </div>
    <!-- 列表 -->
    <div v-if="isClassPage">
      <span class="no-data" v-if="!homeworkList.length">暂无数据</span>
      <div class="course-content">
        <!-- 新UI -->
        <div
          class="list-item"
          v-for="item in homeworkList"
          :key="item.class_id"
        >
          <div class="item-main">
            <img
              style="
                width: 130px;
                height: 86px;
                object-fit: cover;
                border-radius: 6px;
              "
              :src="item.cover"
              alt="封面"
            />
            <div class="right-con">
              <header class="item-title" :title="item.course_name">
                {{ item.course_name }}
              </header>
              <p class="class-title" :title="item.class_name">
                班期：{{ item.class_name }}
              </p>
              <el-progress
                :percentage="Number(item.complete_rate)"
                :format="format"
              ></el-progress>
              <button class="info-btn" @click="toInfo(item)">查看详情</button>
            </div>
          </div>
          <!-- 下方横线 -->
          <el-divider></el-divider>
        </div>
      </div>
      <div class="pagination">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <!-- 详情 -->
    <ViewClassInfo :classId="classId" v-else />
  </div>
</template>

<script>
import ViewClassInfo from './viewClassInfo';
import { getHost } from '../../utils/useProxyApi';
export default {
  components: {
    ViewClassInfo,
  },
  data() {
    return {
      courseName: '',
      classId: '',
      isClassPage: true,
      keyword: '',
      page: 1,
      pagination: {
        page: 1,
        total: 0,
        num: 6,
      },
      homeworkList: [],
      total: 0,
    };
  },
  created() {
    this.getHomeworkList();
  },

  methods: {
    format(percentage) {
      return `已学习${percentage}%`;
    },
    toInfo(item) {
      // 查看详情
      this.classId = item.class_id;
      this.courseName = item.course_name;
      this.isClassPage = false;
    },
    async getHomeworkList() {
      // 获取列表数据
      const data = {
        page: this.page,
        page_nums: 5,
      };
      // if(this.keyword){
      //   data.keyword = this.keyword
      // }
      const res = await this.$tenghuiApi.post(
        `${getHost()}/studentPersonalCenter/getWatchDataList`,
        data
      );
      if (res.data.code == 200) {
        this.homeworkList = res.data.data.list;
        this.total = res.data.data.total;
      }
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getHomeworkList();
    },
    handleSearch() {
      this.page = 1;
      this.getHomeworkList();
    },
  },
};
</script>

<style lang="scss" scoped>
li,
ul,
p,
h4 {
  margin: 0;
  padding: 0;
  list-style: none;
}
th {
  font-weight: normal;
}
.wrap {
  background: #ffffff;
  margin: 25px 0px 25px 25px;
  float: left;
  padding: 20px 30px;
  height: 880px;
  .header {
    padding-bottom: 17px;
    border-bottom: 1px solid #e8eaec;
    display: flex;
    align-items: center;
    .search-box {
      width: 180px;
      margin-left: auto;
      ::v-deep .el-input__inner {
        border: none;
        background: #f7f7f7;
        border-radius: 18px;
      }
      ::v-deep .el-input__suffix {
        color: #1872ed;
      }
      ::v-deep .el-input__suffix {
        top: 9px;
        right: 10px;
        cursor: pointer;
      }
    }
  }
}
.title {
  color: #202020;
  margin: 0;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
}
.red-dot {
  display: inline-block;
  width: 5px;
  height: 5px;
  background-color: red;
  border-radius: 50%;
  margin-left: 5px;
}
.course-content {
  margin-top: 20px;
  box-sizing: border-box;
  font-size: 14px;
  max-height: 700px;
  overflow-y: auto;
  .list-item {
    .item-main {
      display: flex;
      justify-content: space-between;

      .right-con {
        position: relative;
        width: calc(100% - 140px);
        .item-title {
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-400;
          font-weight: 400;
          // 超出隐藏点点点
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: block;
        }
        .class-title {
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-400;
          color: #666;
          margin: 10px 0 14px;
        }
        ::v-deep .el-progress {
          width: 520px;
          display: flex;
          align-items: center;
          .el-progress-bar {
            padding-right: 60px;
          }
          .el-progress__text {
            width: 130px;
            color: #1872ed;
            font-size: 14px;
          }
        }
        .info-btn {
          width: 90px;
          height: 32px;
          background: linear-gradient(107deg, #73aaff 0%, #0053ff 100%);
          border-radius: 6px;
          color: #fff;
          font-size: 14px;
          border: none;
          cursor: pointer;
          position: absolute;
          right: 5px;
          bottom: 0px;
        }
      }
    }
    ::v-deep .el-divider--horizontal {
      margin: 15px 0;
    }
  }
}
.pagination {
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 20px;
}
.pagination >>> .el-pager li:not(.disabled).active {
  background: #1872ed;
}

.no-data {
  width: 100%;
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
